import React, { useEffect } from 'react';
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { saveStoreToStorage } from '../utils/storeUtils';
import { useStores } from '../contexts/StoresContext';

function MainPage() {
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();
  const { isValid, get } = useStores();
  const { storeCode } = useParams<{ storeCode: string }>();

  useEffect(() => {
    if (storeCode && isValid(storeCode)) {
      saveStoreToStorage(storeCode);
    }
  }, [storeCode]);

  if (!storeCode || !isValid(storeCode)) return <Navigate to="/" replace />;

  const store = get(storeCode)!;

  return (
    <div className="App">
      <Header />

      <main className="main-content">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        <img src="/screen.png" className="mascot" alt="Mascot" />
        
        <h1 className="question">
          {language === 'ru' ? 'Вам понравилось обслуживание?' : 'Қызмет көрсету ұнады ма?'}
        </h1>

        <div className="buttons">
          <button className="button primary" onClick={() => navigate(`/${storeCode}/good`)}>
            {language === 'ru' ? 'Все отлично!' : 'Бәрі керемет!'}
          </button>
          <button className="button secondary" onClick={() => navigate(`/${storeCode}/bad`)}>
            {language === 'ru' ? 'Есть претензия' : 'Шағым бар'}
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default MainPage; 